module.exports = __webpack_public_path__ + "img/packages/v5.14b146.png";